export default __webpack_public_path__ + "static/media/3-bg.10bd9dca.png";